<template>
	<div class="main">
      <map-view></map-view>
      <legend-view></legend-view>
      <topList-view></topList-view>
      <calender-view v-if="userConfig.platform == 'base'"></calender-view>
      <report-warm :userConfig="userConfig" v-show="isReport" v-if="userConfig.platform == 'shenyang' && departmentId == 2"></report-warm>
      <magic-nav></magic-nav>
      <select-model v-if="userConfig.platform == 'shenyang'"></select-model>
	</div>
</template>

<script>
import mapView from "./map";
import topListView from "./topList.vue";
import calenderView from "./calender.vue";
import legendView from "./legend.vue";
import magicNav from "./magicNav.vue";
import selectModel from "./selectModel.vue";
import reportWarm from "./reportWarm.vue";

export default {
  components: {
    mapView,
    topListView,
    calenderView,
    legendView,
    magicNav,
    selectModel,
    reportWarm
  },
  data() {
    return {
      userConfig: {},
      departmentId: 0,
      isReport: true
    };
  },
  methods: {},
  mounted() {
    this.$set(
      this,
      "userConfig",
      JSON.parse(window.sessionStorage.getItem("userConfig"))
    );
    this.$set(
      this,
      "departmentId",
      window.sessionStorage.getItem("departmentId")
    );
    this.$root.reportHub.$on("nowClick", () => {
      this.isReport = false;
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/main/main.vue